export default __webpack_public_path__ + "static/media/Florence.77b54aec.jpg";